module.exports = "/img/More-1.a6f25417.png";